import css_01chffofyy6j from './css/TitleBarContainer.css';
import Div from './Div.js';
import MenuButton from './MenuButton.js';
import Title from './Title.js';
import FloatCloseButton from './FloatCloseButton.js';
import Img from "./Img.js";

const css = css_01chffofyy6j;

class TitleBarTitle extends Title
{
	constructor(parentElement)
	{
		super(parentElement);
		this.titleBarFrontImage = null;
	}

	get value()
	{
		return super.value;
	}

	set value(value)
	{
		const oldValue = this.titleBarFrontImage;

		this.titleBarFrontImage = value.length && value[0] && value[0].img || null;

		if(this.titleBarFrontImage)
		{
			value = value.slice(1);
		}
		super.value = value;

		if(this.titleBarFrontImage !== oldValue)
		{
			this.dispatchEvent('titleBarFrontImageChange');
		}
	}

	get className()
	{
		return 'title';
	}
}

export default class TitleBarContainer extends Div
{
	constructor(parentElement)
	{
		super(parentElement);
		this.barkerTitle = new BarkerTitle(this);
		this.frontImage = new Img(this);
		this.prepend = new Prepend(this);
		this.title = new TitleBarTitle(this);
		this.title.element.addEventListener
		(
			'titleBarFrontImageChange',
			e =>
			{
				this.element.classList.toggle('imageFirst',this.title.titleBarFrontImage);
				this.frontImage.value = this.title.titleBarFrontImage;
			}
		);
		this.menuButton = new MenuButton(this);
		this.floatCloseButton = new FloatCloseButton(this);

		this.barkerTitle.value = config.feed.barkerTitle;
	}

	get cssText()
	{
		return css;
	}
}

class Prepend extends Title { }
class BarkerTitle extends Title
{
	get cssText()
	{
		return '.videoPlayer:not(.barker) .barkerTitle{display:none}'
	}
}
